import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { YearSelectorComponent } from './year-selector.component';

import { NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule
  ],
  declarations: [YearSelectorComponent],
  exports: [
    YearSelectorComponent
  ]
})
export class YearSelectorModule { }
